import { ReactComponent as IconInfo } from '@/assets/svgs/icon-info.svg'
import { ReactComponent as IconTick } from '@/assets/svgs/tick.svg'
import classname from 'classnames'


const SelectorBox = ({ active, label, sublabel, submit, hideSelect = false, checkBox = true, removedList = false, handleCheckInfo, image, disabled = false, "data-testid": dataTestId }) => {

	const selectorClass = classname({
		'selector-box-2': true,
		'selector-box-2--active': active,
		'selector-box-2--cursor': hideSelect,
		'selector-box-2--removed': removedList,
		'selector-box-2--disabled': disabled
	})

	return (
		<div data-testid={dataTestId} className={selectorClass} onClick={submit ? (disabled ? null : submit) : null}>
			<div className="selector-box-2__left">
				{
					image && (
						<div className="selector-box-2__avatar" style={{ backgroundImage: `url(${image})` }}></div>
					)
				}

				<div className="selector-box-2__label">
					<div className="selector-box-2__label__top">
						{label}
					</div>
					<div className="selector-box-2__label__bottom">
						<span>{sublabel}</span>
					</div>
				</div>

				{
					handleCheckInfo && (
						<div data-testid="info-icon" className="selector-box-2__info-icon" onClick={handleCheckInfo}><IconInfo /></div>
					)
				}
			</div>


			{
				!hideSelect && checkBox && (
					<div className="selector-box-2__right">
						<div className="selector-box-2__checkbox">{active ? <IconTick data-testid={`${dataTestId}-checked`} /> : null}</div>
					</div>
				)

			}
			{
				!hideSelect && !checkBox && (
					<div className="selector-box-2__right">
						<div className="selector-box-2__circle">{active ? <div data-testid={`${dataTestId}-unchecked`} className='selector-box-2__circle__inner'></div> : null}</div>
					</div>
				)
			}

		</div>

	)
}

export default SelectorBox
